import {
  GET_COMBO_NGUON_KHACH_HANG,
  GET_COMBO_NGUON_KHACH_HANG_SUCCESS,
  GET_COMBO_NGUON_KHACH_HANG_FAILURE,
} from "./actionTypes";

export const getComboNguonKhachHang = (dataSearch) => ({
  type: GET_COMBO_NGUON_KHACH_HANG,
  dataSearch,
});

export const getComboNguonKhachHangSuccess = (data) => ({
  type: GET_COMBO_NGUON_KHACH_HANG_SUCCESS,
  payload: data,
});

export const getComboNguonKhachHangFailure = () => ({
  type: GET_COMBO_NGUON_KHACH_HANG_FAILURE,
});
